import React from "react";
import { LegalLayout } from "@/components/LegalLayout";

const SECTIONS = [
  { h: "What are cookies?", p: [
    "Cookies are small text files placed on your device when you visit a website. Similar technologies, such as browser local storage, work in a similar way. They help websites work and give site owners information about how the site is used.",
  ] },
  { h: "Cookies we use", list: [
    "Strictly necessary — admin login session (access_token): a secure, HTTP-only cookie set only when our staff log in to the admin area. It expires after 12 hours or when they log out.",
    "First-party analytics: when you view a page, we record the page address, time and browser type in our own system so we can see which pages are most useful. We do not use third-party advertising or tracking cookies, and we do not share this data with advertisers.",
  ] },
  { h: "Third-party services", list: [
    "Google Fonts: our typefaces are loaded from Google's servers, which receive your IP address in order to deliver the font files. See Google's privacy policy for details.",
    "Google Maps: if you click our \"Get directions\" link, you will leave our site and Google's own cookie policy applies.",
    "If we add advertising measurement (for example Google Ads conversion tracking) in future, we will update this policy and ask for your consent before setting any non-essential cookies.",
  ] },
  { h: "Managing cookies", p: [
    "You can block or delete cookies through your browser settings. Blocking strictly necessary cookies will only affect the admin login; the public website will continue to work normally. For guidance, visit your browser's help pages or www.aboutcookies.org.",
  ] },
  { h: "Your legal rights", p: [
    "We use cookies in line with the ePrivacy Regulations 2011 (S.I. No. 336 of 2011) and GDPR. For more on how we handle personal data and your rights, see our Privacy Policy, or contact info@roboticlawnmowerexperts.ie.",
  ] },
];

export default function Cookies() {
  return (
    <LegalLayout
      testId="cookies-page"
      title="Cookie Policy"
      intro="This policy explains how Robotic Lawnmower Experts uses cookies and similar technologies on this website."
      sections={SECTIONS}
    />
  );
}
